<template>
    <div class="login-page container vh-100 d-flex align-items-center justify-content-center">
        <div class="row w-100">
            <div class="col-md-6 d-flex flex-column align-items-center justify-content-center">
                <h1>WebLungi</h1>
                <img src="../assets/welcome.png" alt="Welcome" class="img-fluid">
            </div>
            <div class="col-md-6 d-flex align-items-center justify-content-center">
                <LoginForm />
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from './LoginForm.vue';

export default {
    name: 'LoginPage',
    components: {
        LoginForm,
    },
};
</script>

<style scoped>
/* Add your custom styles here */
.login-page {
    height: 100vh; /* Full viewport height */
}
</style>